var Backbone, EmailFormUSLocationElementView, EmailFormUSLocationListView, EmailFormUSMerchantLocationInfoView, SupportMerchantLocationInfoTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportMerchantLocationInfoTemplate = require('../../../../merchant_location_info.html.mustache');

EmailFormUSLocationListView = require("./location_list_view");

EmailFormUSLocationElementView = require("./location_element_view");

Backbone = require('backbone');

Backbone.$ = $;

EmailFormUSMerchantLocationInfoView = (function(superClass) {
  extend(EmailFormUSMerchantLocationInfoView, superClass);

  function EmailFormUSMerchantLocationInfoView() {
    return EmailFormUSMerchantLocationInfoView.__super__.constructor.apply(this, arguments);
  }

  EmailFormUSMerchantLocationInfoView.prototype.tagName = 'li';

  EmailFormUSMerchantLocationInfoView.prototype.className = 'requestedFields';

  EmailFormUSMerchantLocationInfoView.prototype.events = {
    'click #showAllLocations': 'showAllLocations',
    'keyup #businessLocation': 'enableDisableSubmitButton'
  };

  EmailFormUSMerchantLocationInfoView.prototype.initialize = function(options) {
    var i, j, len, location, ref, ref1, ref2, ref3;
    this.options = options || {};
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportMerchantLocationInfoTemplate;
    this.model = this.options.model;
    this.isInputCompulsory = this.model.required;
    if (((ref = Groupon.Support.currentOrder) != null ? (ref1 = ref.dealOption) != null ? (ref2 = ref1.redemptionLocations) != null ? ref2.length : void 0 : void 0 : void 0) > 0) {
      ref3 = Groupon.Support.currentOrder.dealOption.redemptionLocations;
      for (i = j = 0, len = ref3.length; j < len; i = ++j) {
        location = ref3[i];
        location.isSelected = false;
        location.locationId = i;
      }
    }
    this.numberOfRedemptionLocations = this.model.numberOfRedemptionLocations;
    return this.collectFromAvailableLocations = this.numberOfRedemptionLocations > 0;
  };

  EmailFormUSMerchantLocationInfoView.prototype.render = function() {
    this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
    return this.onLocationSelectionDone();
  };

  EmailFormUSMerchantLocationInfoView.prototype.toHash = function() {
    return {
      collectFromAvailableLocations: this.collectFromAvailableLocations,
      numOfRedemptionLocations: this.numberOfRedemptionLocations,
      showAll: this.numberOfRedemptionLocations > 3,
      currentUserAndOrderCheck: (typeof currentUser !== "undefined" && currentUser !== null) && (Groupon.Support.currentOrder != null) ? true : false
    };
  };

  EmailFormUSMerchantLocationInfoView.prototype.showAllLocations = function() {
    var locationListView;
    return locationListView = new EmailFormUSLocationListView({
      'cb': this.onLocationSelectionDone
    });
  };

  EmailFormUSMerchantLocationInfoView.prototype.enableDisableSubmitButton = function() {
    return this.options.validateEmailForm.call();
  };

  EmailFormUSMerchantLocationInfoView.prototype.onLocationSelectionDone = function() {
    var j, len, location, locationView, locationsToShowinMainPage, selectedLocations;
    if (this.numberOfRedemptionLocations > 1) {
      locationsToShowinMainPage = [];
      selectedLocations = this.getSelectedLocations();
      if (selectedLocations.length === 0) {
        locationsToShowinMainPage = _.first(Groupon.Support.currentOrder.dealOption.redemptionLocations, 5);
      } else {
        locationsToShowinMainPage = selectedLocations;
      }
      $('#locations', this.$el).empty();
      for (j = 0, len = locationsToShowinMainPage.length; j < len; j++) {
        location = locationsToShowinMainPage[j];
        locationView = new EmailFormUSLocationElementView({
          'location': location,
          'cb': this.enableDisableSubmitButton
        });
        locationView.render();
        $('#locations', this.$el).append(locationView.el);
      }
      return this.enableDisableSubmitButton();
    }
  };

  EmailFormUSMerchantLocationInfoView.prototype.getSelectedLocations = function() {
    return _.filter(Groupon.Support.currentOrder.dealOption.redemptionLocations, function(location) {
      return location.isSelected === true;
    });
  };

  EmailFormUSMerchantLocationInfoView.prototype.getBusinessLocationElement = function() {
    return this.$el.find('#businessLocation');
  };

  EmailFormUSMerchantLocationInfoView.prototype.populateInput = function(data) {
    var ref, ref1;
    data.businessLocation = (ref = this.getBusinessLocationElement()) != null ? (ref1 = ref.val()) != null ? ref1.trim() : void 0 : void 0;
    return data.merchantInfoView = true;
  };

  EmailFormUSMerchantLocationInfoView.prototype.isInputGiven = function() {
    var ref, ref1;
    if (this.numberOfRedemptionLocations > 0) {
      return this.numberOfRedemptionLocations === 1 || this.getSelectedLocations().length > 0;
    } else {
      return ((ref = this.getBusinessLocationElement()) != null ? (ref1 = ref.val()) != null ? ref1.trim().length : void 0 : void 0) > 0;
    }
  };

  EmailFormUSMerchantLocationInfoView.prototype.isInputValid = function() {
    return true;
  };

  return EmailFormUSMerchantLocationInfoView;

})(Backbone.View);

module.exports = EmailFormUSMerchantLocationInfoView;

//# sourceMappingURL=data:application/json;base64,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
